<script>

export default {
  name: 'InputfieldMixin',
  data: () => ({
    errorsMutable: [],
    errorsVisible: false,
  }),
  props: {
    name: {
      type: String,
      required: false,
    },
    id: {
      type: String,
      required: false,
    },
    value: {
      required: false,
    },
    label: {
      type: String,
      required: false,
      default () {
        return ''
      },
    },
    icon: {
      type: String,
      required: false,
      default () {
        return ''
      },
    },
    description: {
      type: String,
      required: false,
      default () {
        return ''
      },
    },
    notes: {
      type: String,
      required: false,
      default () {
        return ''
      },
    },
    labelClass: {
      type: String,
      required: false,
      default () {
        return ''
      },
    },
    required: {
      type: Boolean,
      required: false,
      default () {
        return false
      },
    },
    hideAsterisk: {
      type: Boolean,
      required: false,
      default () {
        return false
      },
    },
    disabled: {
      type: Boolean,
      required: false,
      default () {
        return false
      },
    },
    errors: {
      type: Object,
      required: false,
      default () {
        return {}
      },
    },
  },
  computed: {
    classObject () {
      return [
        'field',
        'field--' + this.fieldId,
        (this.required && !this.hideAsterisk) ? 'field--required' : null,
        this.disabled ? 'field--disabled' : null,
        this.parsedErrors.length ? 'field--hasErrors' : null,
      ]
    },
    fieldId () {
      return (this.id) ? this.id : this.name
    },
    parsedErrors () {
      if (typeof this.errors != 'object' || !Object.keys(this.errors).length) return []

      const errors = Object.assign([], this.errors[this.id])

      if (!Array.isArray(errors)) return []

      return errors
    },
  },
  methods: {
    clearErrors () {
      this.errorsVisible = false
    },
  },
}

</script>
